import React, { ReactNode } from 'react';

import { Frame, FrameWrapper } from './styles';

type Props = {
  children: ReactNode;
  fullWidth?: boolean;
};

const FormFrame = ({ children, fullWidth = false }: Props): JSX.Element => (
  <FrameWrapper>
    <Frame fullWidth={fullWidth}>{children}</Frame>
  </FrameWrapper>
);

export default FormFrame;
